<template>
    <div class="avatar" :class="getSize(size)">
        <img
            :src="img"
            :alt="alt"
            :class="[getClasses(shadow, circular, borderRadius)]"
            @error="setImageFallback"
        />
    </div>
</template>

<script>
import defaultProductImage from "@/assets/img/no-image.png";

export default {
    name: "ArgonAvatar",
    props: {
        img: {
            type: String,
            required: true,
        },
        alt: {
            type: String,
            default: "",
        },
        size: {
            type: String,
            default: null,
        },
        shadow: {
            type: String,
            default: null,
        },
        borderRadius: {
            type: String,
            default: null,
        },
        circular: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            defaultProductImage,
        };
    },
    methods: {
        setImageFallback(event) {
            const img = event.target;

            if (img && img.src !== this.defaultProductImage) {
                img.src = this.defaultProductImage;
                img.onerror = null;
            }
        },
        getSize: (size) => (size ? `avatar-${size}` : null),
        getClasses: (shadow, circular, borderRadius) => {
            let shadowValue, circularValue, borderRadiusValue;

            if (shadow) {
                shadowValue =
                    shadow === "regular" ? "shadow" : `shadow-${shadow}`;
            } else {
                shadowValue = null;
            }

            circularValue = circular ? "rounded-circle" : null;

            borderRadiusValue = borderRadius
                ? `border-radius-${borderRadius}`
                : null;

            return `${shadowValue} ${circularValue} ${borderRadiusValue}`;
        },
    },
};
</script>
